window.addEventListener('DOMContentLoaded', function(e) {
    let module = document.querySelector('.contact-tab');
    let scrollCount = 0;
    let scrollTop = 0;

    if (module) {
        module.addEventListener('click', (e) => {
            if (e.target.tagName != 'A') {
                module.classList.toggle('open');
                scrollCount = 0;
                scrollTop = parseInt(window.scrollY);
            }
        })

        window.addEventListener('click', function(e) {
            if (e.target.closest('.contact-tab') == null) {
                module.classList.remove('open');
            }
        })

        window.addEventListener('scroll', function(e) {
            let delta = scrollTop - window.scrollY;
            scrollTop = window.scrollY;
            scrollCount += Math.abs(delta);

            if (scrollCount >= 200) {
                module.classList.remove('open');
            }
        })
    }
})